/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserIdQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type CurrentUserIdQuery = { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string } } | null };


export const CurrentUserIdDocument = gql`
    query CurrentUserId {
  authenticatedSession {
    user {
      id
      legacyId
    }
  }
}
    `;

/**
 * __useCurrentUserIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
      }
export function useCurrentUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
        }
export function useCurrentUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
        }
export type CurrentUserIdQueryHookResult = ReturnType<typeof useCurrentUserIdQuery>;
export type CurrentUserIdLazyQueryHookResult = ReturnType<typeof useCurrentUserIdLazyQuery>;
export type CurrentUserIdSuspenseQueryHookResult = ReturnType<typeof useCurrentUserIdSuspenseQuery>;
export type CurrentUserIdQueryResult = Apollo.QueryResult<CurrentUserIdQuery, CurrentUserIdQueryVariables>;